"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const deprecated_1 = require("../node/deprecated");
/**
 * Deprecates a section of a template.
 *
 * <pre>
 * {% deprecated 'The "base.twig" template is deprecated, use "layout.twig" instead.' %}
 *
 * {% extends 'layout.html.twig' %}
 * </pre>
 *
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingTokenParserDeprecated extends token_parser_1.TwingTokenParser {
    parse(token) {
        let expr = this.parser.getExpressionParser().parseExpression();
        this.parser.getStream().expect(token_1.TwingToken.BLOCK_END_TYPE);
        return new deprecated_1.TwingNodeDeprecated(expr, token.getLine(), token.getColumn(), this.getTag());
    }
    getTag() {
        return 'deprecated';
    }
}
exports.TwingTokenParserDeprecated = TwingTokenParserDeprecated;
